import { Navigate } from 'react-router-dom'
import { useAuthSession } from '@/lib/session'

export default function MarkReadyBasPage() {
  const session = useAuthSession()
  if (session?.idToken) {
    return <Navigate to="/" replace />
  }
  return <Navigate to="/login" replace />
}
